/* Registers the service worker that makes Bicarra installable.
 *
 * Development is deliberately excluded. A service worker running against the
 * dev server caches nothing useful and makes hot reload behave strangely.
 */

export default function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // A deploy swaps the whole build directory, so check on every load
        // rather than waiting for the browser's own 24-hour update cycle.
        registration.update().catch(() => {});
      })
      .catch((err) => {
        // Registration failing must never break the app. Worst case the site
        // simply is not installable.
        console.warn("Service worker registration failed:", err);
      });
  });
}
